module.exports = __webpack_public_path__ + "static/tiefling-rogue-phantom-d8e82fd804c8a8fb39399f9a728cf1e9.png";